import { trackEvent, TrackedEvent } from "@/domains/metrics";

export class VoiceAnalyticsTracker {
  sessionStart(payload: { sessionId: string; capturedAudioId: string; noteId: string | null }) {
    const { sessionId, capturedAudioId, noteId } = payload;
    trackEvent(TrackedEvent.VoiceSessionStart, {
      session_id: sessionId,
      captured_audio_id: capturedAudioId,
      note_id: noteId ?? undefined,
    });
  }

  sessionPause(payload: { sessionId: string; capturedAudioId: string; noteId: string | null }) {
    const { sessionId, capturedAudioId, noteId } = payload;
    trackEvent(TrackedEvent.VoiceSessionPause, {
      session_id: sessionId,
      captured_audio_id: capturedAudioId,
      note_id: noteId ?? undefined,
      timestamp: Math.floor(Date.now() / 1000),
    });
  }

  sessionResume(payload: { sessionId: string; capturedAudioId: string; noteId: string | null }) {
    const { sessionId, capturedAudioId, noteId } = payload;
    trackEvent(TrackedEvent.VoiceSessionResume, {
      session_id: sessionId,
      captured_audio_id: capturedAudioId,
      note_id: noteId ?? undefined,
      timestamp: Math.floor(Date.now() / 1000),
    });
  }

  sessionDone(payload: { sessionId: string; capturedAudioId: string; noteId: string | null }) {
    const { sessionId, capturedAudioId, noteId } = payload;
    trackEvent(TrackedEvent.VoiceSessionDone, {
      session_id: sessionId,
      captured_audio_id: capturedAudioId,
      note_id: noteId ?? undefined,
      timestamp: Math.floor(Date.now() / 1000),
    });
  }

  suggestedEditsViewed(payload: {
    sessionId: string;
    capturedAudioId: string;
    noteId: string | null;
    uploadDurationSeconds: number;
    transformDurationSeconds: number;
    totalDurationSeconds: number;
  }) {
    const {
      sessionId,
      capturedAudioId,
      noteId,
      uploadDurationSeconds,
      transformDurationSeconds,
      totalDurationSeconds,
    } = payload;
    trackEvent(TrackedEvent.VoiceSessionSuggestedEditsView, {
      session_id: sessionId,
      captured_audio_id: capturedAudioId,
      note_id: noteId ?? undefined,
      elapsed_time: totalDurationSeconds,
      upload_duration: uploadDurationSeconds,
      transform_note_duration: transformDurationSeconds,
    });
  }
}
